import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { industryNeeds } from '@/mocks/smart-farm-solution';

export default function Needs() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="行业需求"
          title="从追求产量，到追求质量与可持续"
          subtitle="农业正在从单纯追求产量，转向更加重视质量、效率、品牌和可持续经营。农场、合作社及县域农业产业主体，普遍面临以下需求。"
        />
        <Reveal className="mt-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {industryNeeds.map((item, index) => (
              <div
                key={item.id}
                className="relative p-6 rounded-lg bg-background-100 border border-background-200 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_12px_32px_rgba(0,0,0,0.08)]"
              >
                <span className="absolute top-5 right-5 text-3xl font-heading font-bold text-foreground-100 select-none">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <h3 className="mt-5 font-heading font-bold text-foreground-950 text-lg leading-snug">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}